<template>
  <PageTemplate heading="Leieobjekter">
    <InfoCard>
      {{ translate('reports.rentalObjectSettings.infoCard.text') }}
    </InfoCard>

    <BlockContainer class="settings-container mt-4">
      <div class="d-flex">
        <ReportSettingsLandlordSelector v-model="landlordId" />
      </div>
      <table v-if="landlordId !== '__NULL__' && !loading" class="table">
        <thead>
          <tr>
            <th>Gatenavn</th>
            <th>Alias</th>
            <th>ByggID</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in data" :key="row.tenancyId">
            <td>{{ row.rentalObjectStreet }}</td>
            <td>{{ row.rentalObjectAlias }}</td>
            <td>
              <input type="text" v-model="row.customClientId" :disabled="saving" class="form-control form-control-sm" />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="landlordId !== '__NULL__' && !loading" class="buttons">
        <button class="btn btn-primary" @click="save" :disabled="saving">
          {{ saving ? 'Vennligst vent...' : 'Lagre' }}
        </button>
      </div>
    </BlockContainer>
  </PageTemplate>
</template>

<script>
import { LandlordReportApi } from '@modules/husleieapi2';
import BlockContainer from '@/components/BlockContainer';
import ReportSettingsLandlordSelector from '@/components/reports/ReportSettingsLandlordSelector';
import PageTemplate from '@/components/PageTemplate.vue';
import InfoCard from '@/components/InfoCard.vue';
import i18nCommon from '@modules/i18n/mixins/Common';

export default {
  name: 'ReportRentalObjectsSettings',
  data() {
    return {
      data: [],
      loading: false,
      saving: false,
      landlordId: '__NULL__',
    };
  },
  mixins: [i18nCommon],
  components: {
    BlockContainer,
    ReportSettingsLandlordSelector,
    PageTemplate,
    InfoCard,
  },
  watch: {
    landlordId: {
      handler(newId) {
        if (newId !== '__NULL__') {
          this.load(newId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async load(id) {
      this.loading = true;
      const api = new LandlordReportApi();
      this.data = await api.getLandlordReportsSettingsRentalObjects(id);
      this.loading = false;
    },
    async save() {
      this.saving = true;
      const api = new LandlordReportApi();
      this.data = await api.postLandlordReportsSettingsRentalObjects(this.landlordId, { body: this.data });
      this.saving = false;
    },
  },
};
</script>

<style scoped lang="scss">
.settings-container {
  padding: 1.25rem;
}

.buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
